module.exports = __webpack_public_path__ + "static/media/theme.97e2c39a.svg";